import { IMAGES } from "./images";

export const TESTIMONIALS = [
  {
    id: 1,
    name: "Priya Sharma",
    position: "MS Computer Science, University of Toronto",
    comment:
      "Ever Sky Overseas made my dream of studying in Canada a reality. From university selection to visa approval, their team was supportive every step of the way. I received my study permit in just 6 weeks!",
    image: IMAGES.testimonials[0],
  },
  {
    id: 2,
    name: "Rahul Mehta",
    position: "MBA, University of Melbourne",
    comment:
      "I was struggling with my SOP until I found Ever Sky. Their writers crafted an outstanding statement that got me into my dream business school. The scholarship guidance was an added bonus — I saved over ₹8 lakhs!",
    image: IMAGES.testimonials[1],
  },
  {
    id: 3,
    name: "Ananya Patel",
    position: "BSc Nursing, King's College London",
    comment:
      "As a first-generation student going abroad, I had so many questions. The counsellors at Ever Sky were patient, knowledgeable, and always available. Accommodation and SIM card services made my arrival completely stress-free.",
    image: IMAGES.testimonials[2],
  },
  {
    id: 4,
    name: "Vikram Singh",
    position: "MS Data Science, Arizona State University",
    comment:
      "After a visa rejection from another agency, Ever Sky helped me reapply with a stronger case. Their mock interview sessions were incredibly helpful. Got approved on my second attempt!",
    image: IMAGES.testimonials[3],
  },
];
